import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import FooterToolBar from '@/components/tool/FooterToolBar';
import { deleteAddress, getAccountDetail, getAddressDetail } from '@/services/customer/customerList';
import { getErpGroupList } from '@/services/customer/erpGrouped';
import { getCustomerDetail, changApprovalResult } from '@/services/customer/erpCustomerList';
import erpGoods from './erpGoods.vue';
export default {
  components: {
    FooterToolBar: FooterToolBar,
    erpGoods: erpGoods
  },
  i18n: require('./i18n-customer'),
  data: function data() {
    var _this = this;
    var addressColumns = [{
      title: this.$t('customerList.destinationCode'),
      dataIndex: 'destinationCode',
      key: 'destinationCode',
      width: '15%'
    }, {
      title: this.$t('customerList.name'),
      dataIndex: 'name',
      key: 'name',
      width: '15%'
    }, {
      title: this.$t('customerList.email2'),
      dataIndex: 'post',
      key: 'post',
      width: '10%'
    }, {
      title: this.$t('customerList.addressDetail'),
      dataIndex: 'addressDetail',
      key: 'addressDetail',
      scopedSlots: {
        customRender: 'addressDetail' //自定义表格里面的内容
      },
      ellipsis: true,
      width: '20%'
    }, {
      title: this.$t('customerList.phone2'),
      dataIndex: 'phone',
      key: 'phone',
      scopedSlots: {
        customRender: 'phone' //自定义表格里面的内容
      },
      width: '10%'
    }, {
      title: this.$t('customerList.defaultAddress'),
      dataIndex: 'defaultAddress',
      key: 'defaultAddress',
      scopedSlots: {
        customRender: 'defaultAddress' //自定义表格里面的内容
      },
      align: 'center',
      width: '7%'
    }, {
      title: this.$t('customerList.delayTime'),
      dataIndex: 'leadTime',
      key: 'leadTime',
      width: '10%',
      align: 'right'
    }, {
      title: this.$t('customerList.updateTime'),
      dataIndex: 'lastUpdateTime',
      key: 'lastUpdateTime',
      width: '10%'
    }, {
      title: this.$t('customerList.erpLastUpdateTime'),
      dataIndex: 'erpLastUpdateTime',
      key: 'erpLastUpdateTime',
      width: '10%'
    }, {
      title: this.$t('publicuse.action'),
      dataIndex: 'action',
      key: 'action',
      scopedSlots: {
        customRender: 'action'
      },
      width: '10%'
    }];
    var erpColumns = [{
      title: this.$t('customerList.customerInfo2'),
      dataIndex: 'dyxName',
      key: 'dyxName',
      width: '20%'
    }, {
      title: this.$t('customerList.preGet'),
      dataIndex: 'preGet',
      key: 'preGet',
      scopedSlots: {
        customRender: 'preGet' //自定义表格里面的内容
      },
      width: '40%'
    }, {
      title: this.$t('customerList.afterGet'),
      dataIndex: 'afterGet',
      key: 'afterGet',
      scopedSlots: {
        customRender: 'afterGet' //自定义表格里面的内容
      },
      width: '40%'
    }];
    var fistTimeColumns = [{
      title: this.$t('customerList.customerInfo2'),
      dataIndex: 'dyxName',
      key: 'dyxName',
      width: '20%'
    }, {
      title: '',
      dataIndex: 'preGet',
      key: 'preGet',
      scopedSlots: {
        customRender: 'preGet' //自定义表格里面的内容
      },
      width: '40%'
    }];
    return {
      addressColumns: addressColumns,
      addressData: [],
      addressTotal: 0,
      addressPagenation: {
        pageSizeOptions: ['5', '10', '20'],
        total: 0,
        showTotal: function showTotal(total, r) {
          return "".concat(_this.$t('public.total'), "\uFF1A") + _this.addressPagenation.total;
        },
        pageSize: 5,
        current: 1,
        showSizeChanger: true,
        'show-quick-jumper': true
      },
      form: {
        customerEmail: '',
        customerPhone: '',
        approvalResult: null,
        erpCustomerCode: '',
        erpCustomerName: '',
        erpCustomerStatus: null,
        erpCustomerPhone: '',
        email: '',
        addressDetail2: '',
        department: '',
        sellerName: '',
        busFormatName: '',
        payerCode: '',
        payWayStr: '',
        tradeTerm: '',
        inviteCode: '',
        deliveryWayStr: [],
        customerGroupIds: []
      },
      // 备注
      remarkNickname: '',
      remarkNicknameDisabled: false,
      totalLoading: false,
      transportTypeList: [{
        value: '2',
        name: this.$t('customerList.sendbyPost')
      }, {
        value: '0',
        name: this.$t('customerList.pickUp')
      }, {
        value: '1',
        name: this.$t('customerList.zibianshe')
      }],
      payWayObj: {
        '0': this.$t('customerList.payway1'),
        '1': this.$t('customerList.payway2'),
        '2': this.$t('customerList.payway3')
      },
      partmentObj: {
        '1': this.$t('customerList.partment1'),
        '2': this.$t('customerList.partment2')
      },
      // 支付方式
      payMethodList: [{
        value: '0',
        name: this.$t('customerList.payway1')
      }, {
        value: '1',
        name: this.$t('customerList.payway2')
      }, {
        value: '2',
        name: this.$t('customerList.payway3')
      }],
      dysGroupedList: [],
      showCode: false,
      visibleErp: false,
      confirmLoadingErp: false,
      searchForm: {
        erpCustomerCode: ''
      },
      erpColumns: erpColumns,
      erpData: [],
      customerId: undefined,
      erpCustomerId: undefined,
      addressLoading: false,
      bindLoading: false,
      resData: [],
      addressDetailBind: '',
      activeKey: '1',
      appinfo: '',
      password: '',
      // 密码
      customerNickname: '',
      // 店名·担当者名
      deliveryTime: '',
      //到着时间
      firstTimeInfo: null,
      //客户首次提交的得意先信息
      firstTimeInfoVisible: false,
      fistTimeColumns: fistTimeColumns,
      registerErpCustomerVo: null //
    };
  },
  mounted: function mounted() {
    var _this$$route$query$cu, _this$$route$query$er;
    this.customerId = (_this$$route$query$cu = this.$route.query.customerId) !== null && _this$$route$query$cu !== void 0 ? _this$$route$query$cu : '';
    this.erpCustomerId = (_this$$route$query$er = this.$route.query.erpCustomerId) !== null && _this$$route$query$er !== void 0 ? _this$$route$query$er : '';
    this.initData();
  },
  methods: {
    onCheckDeliveryWay: function onCheckDeliveryWay(rule, value, callback) {
      console.log({
        rule: rule,
        value: value,
        callback: callback
      });
      if (this.form.payWayStr.length === 1 && this.form.payWayStr == '2' && (value.indexOf('0') >= 0 || value.indexOf('1') >= 0)) {
        callback(new Error(this.$t('customer.mastPostTip2')));
      } else if (this.form.payWayStr.indexOf('2') >= 0 && value.indexOf('2') < 0) {
        callback(new Error(this.$t('customer.mastPostTip')));
      } else {
        callback();
      }
    },
    onConfirmFirstTimeInfo: function onConfirmFirstTimeInfo() {
      this.firstTimeInfo = null;
      this.firstTimeInfoVisible = false;
    },
    // 查看客户首次提交的得意先信息
    showCustomerFirstTimeInfo: function showCustomerFirstTimeInfo() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var bindData;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              try {
                bindData = [{
                  dyxName: _this2.$t('customerList.dyxName'),
                  prename: '',
                  aftername: '',
                  type: 'erpCustomerName'
                },
                // {
                //   dyxName:this.$t('customerList.erpCustomerStatus'),
                //   prename:this.form.erpCustomerStatus == 1 ? this.$t('customerList.normal') : this.$t('customerList.notNormal'),
                //   aftername:'',
                //   type:'erpCustomerStatus'
                // },
                {
                  dyxName: _this2.$t('customerList.erpCustomerPhone'),
                  prename: '',
                  aftername: '',
                  type: 'erpCustomerPhone'
                }, {
                  dyxName: _this2.$t('customerList.email2'),
                  prename: '',
                  aftername: '',
                  type: 'addressPost'
                }, {
                  dyxName: _this2.$t('customerList.addressDetail'),
                  prename: '',
                  aftername: '',
                  type: 'addressDetail'
                }, {
                  dyxName: _this2.$t('customerList.customerStatus4'),
                  prename: '',
                  aftername: '',
                  type: 'busFormatName'
                }];
                _this2.firstTimeInfo = bindData.map(function (item) {
                  item.prename = _this2.registerErpCustomerVo[item.type];
                  return item;
                });
                _this2.firstTimeInfoVisible = true;
                // const res = await getCustomerFirstTimeInfo()
                // if(res.data.code === 200) {
                //   // this.firstTimeInfo = res.data.data
                //
                //   let bindData = [
                //     {
                //       dyxName:this.$t('customerList.dyxName'),
                //       prename: '',
                //       aftername:'',
                //       type:'erpCustomerName'
                //     },
                //     // {
                //     //   dyxName:this.$t('customerList.erpCustomerStatus'),
                //     //   prename:this.form.erpCustomerStatus == 1 ? this.$t('customerList.normal') : this.$t('customerList.notNormal'),
                //     //   aftername:'',
                //     //   type:'erpCustomerStatus'
                //     // },
                //     {
                //       dyxName:this.$t('customerList.erpCustomerPhone'),
                //       prename: '',
                //       aftername:'',
                //       type:'erpCustomerPhone'
                //     },
                //     {
                //       dyxName:this.$t('customerList.email2'),
                //       prename: '',
                //       aftername:'',
                //       type:'addressPost'
                //     },
                //     {
                //       dyxName:this.$t('customerList.addressDetail'),
                //       prename: '',
                //       aftername:'',
                //       type:'addressDetail'
                //     },
                //     {
                //       dyxName:this.$t('customerList.departmentName'),
                //       prename: '',
                //       aftername:'',
                //       type:'department'
                //     },
                //     {
                //       dyxName:this.$t('customerList.customerStatus5'),
                //       prename: '',
                //       aftername:'',
                //       type:'sellername'
                //     },
                //     {
                //       dyxName:this.$t('customerList.customerStatus4'),
                //       prename: '',
                //       aftername:'',
                //       type:'busFormatName'
                //     },
                //     {
                //       dyxName:this.$t('customerList.payerCode'),
                //       prename: '',
                //       aftername:'',
                //       type:'payerCode'
                //     },
                //     {
                //       dyxName:this.$t('customer.paytype'),
                //       prename: '',
                //       aftername:'',
                //       type:'payWay'
                //     },  {
                //       dyxName:this.$t('customerList.quoteCondition'),
                //       prename: '',
                //       aftername:'',
                //       type:'tradeTerm'
                //     },
                //   ]
                //
                // this.firstTimeInfo = bindData.map(item => {
                //   item[item.type] = res.data.data[item.type]
                //   return item
                // })
                //
                //
                //   this.firstTimeInfoVisible = true
                // }
              } catch (e) {
                console.log('e', e);
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /**
     * 确认删除地址
     * @param record 当前行数据
     * @returns {Promise<void>}
     */
    confirmDeleteAddress: function confirmDeleteAddress(record) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return deleteAddress(record.id);
            case 1:
              res = _context2.v;
              if (res.data.code === 200) {
                _this3.$message.success(_this3.$t('public.deleteSuccessfully'));
                _this3.getAddressData();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.error('error', _t);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }))();
    },
    /**
     * 取消确认删除地址
     */
    cancelDeleteAddress: function cancelDeleteAddress() {},
    changeTab: function changeTab(value) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this4.activeKey = value;
              if (value == 2) {
                _this4.addressPagenation.current = 1;
                _this4.getAddressData();
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getAddressData: function getAddressData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var params3, res2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.p = 0;
              _this5.addressLoading = true;
              // 获取地址信息
              params3 = {
                erpCustomerId: _this5.erpCustomerId,
                page: _this5.addressPagenation.current,
                size: _this5.addressPagenation.pageSize
              };
              _context4.n = 1;
              return getAddressDetail(params3);
            case 1:
              res2 = _context4.v;
              if (res2.data.code == 200) {
                _this5.addressData = res2.data.data.list;
                _this5.addressPagenation.total = res2.data.data.total;
              }
            case 2:
              _context4.p = 2;
              _this5.addressLoading = false;
              return _context4.f(2);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, null, [[0,, 2, 3]]);
      }))();
    },
    initData: function initData() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var params, res, row, params2, res3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              params = {
                customerId: _this6.customerId,
                erpCustomerId: _this6.erpCustomerId
              };
              _this6.totalLoading = true;
              _context5.p = 1;
              _context5.n = 2;
              return getAccountDetail(params);
            case 2:
              res = _context5.v;
              if (res.data.code == 200) {
                row = res.data.data;
                if (row.inviteCode !== '' && row.inviteCode !== null && row.inviteCode !== undefined) {
                  _this6.showCode = true;
                }
                _this6.remarkNicknameDisabled = row.customerEmail || row.customerPhone ? false : true;
                _this6.registerErpCustomerVo = row.registerErpCustomerVo;
                _this6.getForm(row);
                // 如果支付方法只有货到付款，货运方式只能是邮寄
                if (row.payWay.length == 1 && row.payWay == '2') {
                  _this6.transportTypeList = [{
                    value: '2',
                    name: _this6.$t('customerList.sendbyPost')
                  }, {
                    value: '0',
                    name: _this6.$t('customerList.pickUp'),
                    disabled: false
                  }, {
                    value: '1',
                    name: _this6.$t('customerList.zibianshe'),
                    disabled: false
                  }];
                }
              }

              // 调取接口获得分组选项
              params2 = {
                sence: 2
              };
              _context5.n = 3;
              return getErpGroupList(params2);
            case 3:
              res3 = _context5.v;
              if (res.data.code == 200) {
                _this6.dysGroupedList = res3.data.data.list.map(function (item) {
                  return {
                    value: item.groupId,
                    name: item.groupName
                  };
                });
              }
            case 4:
              _context5.p = 4;
              _this6.totalLoading = false;
              return _context5.f(4);
            case 5:
              return _context5.a(2);
          }
        }, _callee5, null, [[1,, 4, 5]]);
      }))();
    },
    getForm: function getForm(row) {
      this.appinfo = row.appinfo;
      this.remarkNickname = row.note ? row.note : this.remarkNickname;
      this.customerNickname = row.customerNickname || '';
      this.form = {
        customerEmail: row.customerEmail ? row.customerEmail : this.form.customerEmail,
        customerPhone: row.customerPhone ? row.customerPhone : this.form.customerPhone,
        approvalResult: row.approvalResult ? row.approvalResult : this.form.approvalResult,
        erpCustomerCode: row.erpCustomerCode,
        erpCustomerName: row.erpCustomerName,
        erpCustomerStatus: row.erpCustomerStatus,
        erpCustomerPhone: row.erpCustomerPhone,
        email: row.addressPost,
        addressDetail2: row.provinceName + row.addressDetail,
        department: this.partmentObj[row.department],
        sellerName: row.sellername,
        busFormatName: row.busFormatName,
        payerCode: row.payerCode,
        payWayStr: row.payWay ? row.payWay.split(',') : [],
        tradeTerm: row.tradeTerm,
        inviteCode: row.inviteCode,
        deliveryWayStr: row.deliveryWay ? row.deliveryWay.split(',') : [],
        customerGroupIds: row.customerGroupIds,
        customerId: this.customerId,
        erpCustomerId: this.erpCustomerId,
        phoneType: row.erpCustomerPhoneType,
        addressPost: row.addressPost,
        provinceId: row.provinceId,
        provinceName: row.provinceName,
        addressDetail: row.addressDetail,
        sellerCode: row.sellerCode,
        busFormatCode: row.busFormatCode,
        payerName: row.payerName,
        erpLastUpdateTime: row.erpLastUpdateTime
      };
    },
    handleOkErp: function handleOkErp() {
      this.visibleErp = false;
      if (this.erpData.length > 0) {
        var row = this.resData;
        this.getForm(row);
        this.$refs.editDyx.clearValidate();
      }
      this.resetSearch();
    },
    handleCancelErp: function handleCancelErp() {
      this.visibleErp = false;
      this.resetSearch();
    },
    bindErp: function bindErp() {
      this.visibleErp = true;
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        erpCustomerCode: ''
      };
      this.erpData = [];
      this.$refs.bindVisible.clearValidate();
    },
    getSearch: function getSearch() {
      var _this7 = this;
      {
        this.$refs.bindVisible.validate(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(valid) {
            var params, res, bindData;
            return _regenerator().w(function (_context6) {
              while (1) switch (_context6.n) {
                case 0:
                  if (!valid) {
                    _context6.n = 4;
                    break;
                  }
                  _context6.p = 1;
                  _this7.bindLoading = true;
                  params = {
                    erpCustomerCode: _this7.searchForm.erpCustomerCode
                  };
                  _context6.n = 2;
                  return getCustomerDetail(params);
                case 2:
                  res = _context6.v;
                  if (res.data.code == 200) {
                    bindData = [{
                      dyxName: _this7.$t('customerList.dyxName'),
                      prename: _this7.form.erpCustomerName,
                      aftername: '',
                      type: 'erpCustomerName'
                    }, {
                      dyxName: _this7.$t('customerList.erpCustomerStatus'),
                      prename: _this7.form.erpCustomerStatus == 1 ? _this7.$t('customerList.normal') : _this7.$t('customerList.notNormal'),
                      aftername: '',
                      type: 'erpCustomerStatus'
                    }, {
                      dyxName: _this7.$t('customerList.erpCustomerPhone'),
                      prename: _this7.form.erpCustomerPhone,
                      aftername: '',
                      type: 'erpCustomerPhone'
                    }, {
                      dyxName: _this7.$t('customerList.email2'),
                      prename: _this7.form.email,
                      aftername: '',
                      type: 'addressPost'
                    }, {
                      dyxName: _this7.$t('customerList.addressDetail'),
                      prename: _this7.form.addressDetail,
                      aftername: '',
                      type: 'addressDetail'
                    }, {
                      dyxName: _this7.$t('customerList.departmentName'),
                      prename: _this7.form.department,
                      aftername: '',
                      type: 'department'
                    }, {
                      dyxName: _this7.$t('customerList.customerStatus5'),
                      prename: _this7.form.sellerName,
                      aftername: '',
                      type: 'sellername'
                    }, {
                      dyxName: _this7.$t('customerList.customerStatus4'),
                      prename: _this7.form.busFormatName,
                      aftername: '',
                      type: 'busFormatName'
                    }, {
                      dyxName: _this7.$t('customerList.payerCode'),
                      prename: _this7.form.payerCode,
                      aftername: '',
                      type: 'payerCode'
                    }, {
                      dyxName: _this7.$t('customer.paytype'),
                      prename: _this7.form.payWayStr.length > 0 ? _this7.transList2str(_this7.form.payWayStr) : '--',
                      aftername: '',
                      type: 'payWay'
                    }, {
                      dyxName: _this7.$t('customerList.quoteCondition'),
                      prename: _this7.form.tradeTerm,
                      aftername: '',
                      type: 'tradeTerm'
                    }];
                    _this7.resData = res.data.data;
                    _this7.deliveryTime = res.data.data.deliveryTime;
                    console.log('this.resData', _this7.resData);
                    _this7.addressDetailBind = _this7.resData.provinceName + _this7.resData.addressDetail;
                    bindData.forEach(function (item, index, arr) {
                      for (var i in _this7.resData) {
                        if (i == item.type) {
                          arr[index].aftername = _this7.resData[i];
                          if (i == 'payWay') {
                            var l = _this7.resData[i].split(',');
                            console.log(l, 'lllllllllllll');
                            if (l.length > 0) {
                              arr[index].aftername = _this7.transList2str(l);
                            }
                          }
                          if (i == 'department') {
                            arr[index].aftername = _this7.partmentObj[arr[index].aftername];
                          }
                          if (i == 'erpCustomerStatus') {
                            arr[index].aftername = arr[index].aftername == 1 ? _this7.$t('customerList.normal') : _this7.$t('customerList.notNormal');
                          }
                          if (i == 'addressDetail') {
                            arr[index].aftername = _this7.addressDetailBind;
                          }
                        }
                      }
                    });
                    _this7.erpData = bindData;
                  }
                case 3:
                  _context6.p = 3;
                  _this7.bindLoading = false;
                  return _context6.f(3);
                case 4:
                  return _context6.a(2);
              }
            }, _callee6, null, [[1,, 3, 4]]);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    },
    // 数组转字符串
    transList2str: function transList2str(l) {
      var name = '';
      for (var i = 0; i < l.length; i++) {
        console.log(i, 'iiiiiiiiiiii');
        if (i > 0) {
          name = name + ',' + this.payWayObj[l[i]];
        } else {
          name = name + this.payWayObj[l[i]];
        }
      }
      return name;
    },
    saveAllMethod: function saveAllMethod(type) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var newparams, i, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _this8.totalLoading = true;
              _context7.p = 1;
              newparams = _.cloneDeep(_this8.form);
              newparams.deliveryWayStr = newparams.deliveryWayStr ? newparams.deliveryWayStr.join(',') : '';
              newparams.payWayStr = newparams.payWayStr ? newparams.payWayStr.join(',') : '';
              newparams.customerGroupIds = newparams.customerGroupIds ? newparams.customerGroupIds.join(',') : '';
              if (newparams.department) {
                for (i in _this8.partmentObj) {
                  if (_this8.partmentObj[i] == newparams.department) {
                    newparams.department = i;
                  }
                }
              }
              newparams.type = type;
              newparams.note = _this8.remarkNickname;
              newparams.pwd = _this8.password;
              if (_this8.resData) {
                newparams.leadTime = _this8.resData.leadTime;
              }
              if (_.isNumber(_this8.deliveryTime)) {
                newparams.deliveryTime = _this8.deliveryTime;
              }
              _context7.n = 2;
              return changApprovalResult(newparams);
            case 2:
              res = _context7.v;
              if (!(res.data.code == 200)) {
                _context7.n = 3;
                break;
              }
              if (res.data && res.data.data !== parseInt(_this8.erpCustomerId)) {
                _this8.$router.replace({
                  path: '/customermanager/editcustomer2',
                  query: {
                    customerId: _this8.customerId,
                    erpCustomerId: res.data.data
                  }
                });
              }
              _this8.$message.success(_this8.$t('public.updateSuccessfully'));
              // 还要获取地址的信息
              _this8.erpCustomerId = res.data.data;
              _context7.n = 3;
              return _this8.initData();
            case 3:
              _context7.p = 3;
              _this8.totalLoading = false;
              return _context7.f(3);
            case 4:
              return _context7.a(2);
          }
        }, _callee7, null, [[1,, 3, 4]]);
      }))();
    },
    saveAll: function saveAll(type) {
      var _this9 = this;
      console.log(type, 'type......');
      if (type == 2 || type == 1) {
        this.$refs.editDyx.validate(/*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(valid) {
            return _regenerator().w(function (_context8) {
              while (1) switch (_context8.n) {
                case 0:
                  if (valid) {
                    // this.totalLoading = true
                    // try {
                    //     let newparams = _.cloneDeep(this.form)
                    //     newparams.deliveryWayStr = newparams.deliveryWayStr?  newparams.deliveryWayStr.join(',') : ''
                    //     newparams.payWayStr = newparams.payWayStr ? newparams.payWayStr.join(',') : ''
                    //     newparams.customerGroupIds = newparams.customerGroupIds? newparams.customerGroupIds.join(',') : ''
                    //     if(newparams.department) {
                    //         for(let i in this.partmentObj) {
                    //             if(this.partmentObj[i] == newparams.department){
                    //                 newparams.department = i
                    //             }
                    //         }
                    //     }
                    //     newparams.type = type
                    //     const res = await changApprovalResult(newparams)
                    //     if(res.data.code == 200) {
                    //         this.$router.replace({ path: '/customermanager/editcustomer2', query: { customerId: this.customerId,erpCustomerId: res.data.data } })
                    //         this.$message.success(this.$t('public.updateSuccessfully'))
                    //         this.erpCustomerId = res.data.data 
                    //         this.initData()

                    //     }
                    // }finally {
                    //     this.totalLoading = false
                    // }
                    _this9.saveAllMethod(type);
                  }
                case 1:
                  return _context8.a(2);
              }
            }, _callee8);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      } else {
        this.$refs.editDyx.clearValidate();
        this.saveAllMethod(type);
      }
    },
    tableChange: function tableChange(pagination, filters, sorter, _ref3) {
      var currentDataSource = _ref3.currentDataSource;
      this.addressPagenation.current = pagination.current;
      this.addressPagenation.pageSize = pagination.pageSize;
      this.getAddressData();
    }
  }
};